const disableDescendants = function (containerId) {
  let descendants = $('#' + containerId).find('*');
  descendants.attr('disabled', true);
  descendants.addClass('disabled-by-field-authority');
}

export default {
  disableDescendants,
};
